import React from "react";
import { motion } from "framer-motion";
import { SilhouetteVehicle } from "./SilhouetteVehicle";
import { StatusChip } from "./StatusChip";

/**
 * HeroDossier — bandeau signature pour la fiche dossier.
 * Photo (ou silhouette dark) full-bleed avec léger gradient + infos superposées.
 * Aucun bouton ni CTA ici : la Next Action est plus bas.
 */
export function HeroDossier({ dossier, testid }) {
  const {
    vehicle,
    variant,
    plate,
    client,
    clientLocation,
    image,
    silhouette = "coupe",
    statusLabel = "Livraison en préparation",
    statusChip = "encours",
  } = dossier;

  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      data-testid={testid}
      className="shadow-wyvio-elev relative overflow-hidden rounded-[28px] bg-[#151515]"
    >
      <div className="relative aspect-[21/7] w-full">
        {image ? (
          <img
            src={image}
            alt={vehicle}
            className="h-full w-full object-cover"
          />
        ) : (
          <SilhouetteVehicle
            type={silhouette}
            variant="dark"
            className="h-full w-full"
          />
        )}

        {/* Gradient bas pour lisibilité du texte */}
        <div
          aria-hidden
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(21,21,21,0.15) 0%, rgba(21,21,21,0) 40%, rgba(21,21,21,0.65) 100%)",
          }}
        />

        {/* Chip statut en haut à droite */}
        <div className="absolute right-8 top-8">
          <StatusChip
            status={statusChip}
            label={statusLabel}
            className="!bg-white/12 !text-white backdrop-blur-md"
          />
        </div>

        {/* Infos superposées en bas */}
        <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-10 p-10 text-white">
          <div>
            <p className="wyvio-tabular text-[11px] font-medium uppercase tracking-[0.28em] text-white/55">
              {plate}
            </p>
            <h1 className="mt-3 text-[64px] font-medium leading-[0.98] tracking-[-0.032em]">
              {vehicle}
            </h1>
            {variant && (
              <p className="mt-2 text-[16px] font-normal text-white/70">
                {variant}
              </p>
            )}
          </div>

          <div className="text-right">
            <p className="text-[10.5px] font-medium uppercase tracking-[0.22em] text-white/45">
              Client
            </p>
            <p className="mt-2 text-[15px] font-medium tracking-[-0.005em] text-white">
              {client}
            </p>
            {clientLocation && (
              <p className="mt-1 text-[13px] font-normal text-white/60">
                {clientLocation}
              </p>
            )}
          </div>
        </div>
      </div>
    </motion.section>
  );
}
